import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';
export interface IProfileTexts extends ITextBase {
    suggestChanges: string;
    description: string;
    availability: string;
    empty: string;
    loading: string;
    similarUsers: string;
    skills: string;
    certificates: string;
    editMyProfile: string;
    orgUnit: string;
    availabilityAndProjects: string;
    manageAvailabilityAndProjects: string;
    aboutMe: string;
    about: string;
    noDescriptionAvailable: string;
    contactInformation: string;
    email: string;
    phone: string;
    noEmailProvided: string;
    noPhoneProvided: string;
    competences: string;
    roles: string;
    chipView: string;
    listView: string;
    all: string;
    skillsSearch: string;
    rolesSearch: string;
    editRoles: string;
    superPowers: string;
}
type ILangData = {
    [lang in ELanguage]: IProfileTexts;
};
export const profileTexts: ILangData = {
    th: {
        suggestChanges: 'เสนอการเปลี่ยนแปลง',
        oftenUsed: oftenUsedTranslations.th,
        loading: oftenUsedTranslations.th.loading,
        orgUnit: 'หน่วยงาน',
        editMyProfile: 'แก้ไขโปรไฟล์ของฉัน',
        skills: oftenUsedTranslations.th.skills,
        certificates: oftenUsedTranslations.th.certificates,
        similarUsers: 'พนักงานที่คล้ายกัน',
        empty: oftenUsedTranslations.th.empty,
        availability: oftenUsedTranslations.th.availability,
        description: oftenUsedTranslations.th.description,
        availabilityAndProjects: 'ความพร้อมและโครงการ',
        manageAvailabilityAndProjects: 'จัดการความพร้อมและโครงการ',
        aboutMe: 'เกี่ยวกับฉัน',
        about: 'เกี่ยวกับ',
        noDescriptionAvailable: 'ไม่มีคำอธิบาย',
        contactInformation: 'ข้อมูลติดต่อ',
        email: 'อีเมล',
        phone: 'โทรศัพท์',
        noEmailProvided: 'ไม่ได้ระบุอีเมล',
        noPhoneProvided: 'ไม่ได้ระบุหมายเลขโทรศัพท์',
        competences: 'ความสามารถ',
        roles: 'บทบาท',
        chipView: 'มุมมองชิป',
        listView: 'มุมมองรายการ',
        all: 'ทั้งหมด',
        skillsSearch: 'ค้นหาทักษะ',
        rolesSearch: 'ค้นหาบทบาท',
        editRoles: 'แก้ไขบทบาท',
        superPowers: 'พลังพิเศษ',
    },
    en: {
        suggestChanges: 'Suggest changes',
        oftenUsed: oftenUsedTranslations.en,
        loading: oftenUsedTranslations.en.loading,
        orgUnit: 'Organisational unit',
        editMyProfile: 'Edit my profile',
        skills: oftenUsedTranslations.en.skills,
        certificates: oftenUsedTranslations.en.certificates,
        similarUsers: 'Similar employees',
        empty: oftenUsedTranslations.en.empty,
        availability: oftenUsedTranslations.en.availability,
        description: oftenUsedTranslations.en.description,
        availabilityAndProjects: 'Availability & Projects',
        manageAvailabilityAndProjects: 'Manage Availability & Projects',
        aboutMe: 'About me',
        about: 'About',
        noDescriptionAvailable: 'No description available',
        contactInformation: 'Contact Information',
        email: 'Email',
        phone: 'Phone',
        noEmailProvided: 'No email provided',
        noPhoneProvided: 'No phone number provided',
        competences: 'Competences',
        roles: 'Roles',
        chipView: 'Chip View',
        listView: 'List View',
        all: 'All',
        skillsSearch: 'Skills Search',
        rolesSearch: 'Roles Search',
        editRoles: 'Edit Roles',
        superPowers: 'Super Powers',
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        loading: oftenUsedTranslations.de.loading,
        orgUnit: oftenUsedTranslations.de.orgUnit,
        editMyProfile: 'Mein Profil bearbeiten',
        skills: oftenUsedTranslations.de.skills,
        certificates: oftenUsedTranslations.de.certificates,
        similarUsers: 'Ähnliche Mitarbeiter',
        empty: oftenUsedTranslations.de.empty,
        availability: oftenUsedTranslations.de.availability,
        description: oftenUsedTranslations.de.description,
        suggestChanges: 'Änderungen vorschlagen',
        availabilityAndProjects: 'Verfügbarkeit & Projekte',
        manageAvailabilityAndProjects: 'Verfügbarkeit & Projekte verwalten',
        aboutMe: 'Über mich',
        about: 'Über',
        noDescriptionAvailable: 'Keine Beschreibung verfügbar',
        contactInformation: 'Kontaktinformationen',
        email: 'E-Mail',
        phone: 'Telefon',
        noEmailProvided: 'Keine E-Mail angegeben',
        noPhoneProvided: 'Keine Telefonnummer angegeben',
        competences: 'Kompetenzen',
        roles: 'Rollen',
        chipView: 'Chip-Ansicht',
        listView: 'Listen-Ansicht',
        all: 'Alle',
        skillsSearch: 'Fähigkeiten-Suche',
        rolesSearch: 'Rollen-Suche',
        editRoles: 'Rollen bearbeiten',
        superPowers: 'SuperPowers',
    },
};
